import React, { useState, useEffect } from 'react';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import BottomNav, { TabKey } from './components/BottomNav';
import ErrorBoundary from './components/ErrorBoundary';
import { LanguageProvider } from './i18n/LanguageContext';
import axios from 'axios';
import TreasuresScreen from './screens/TreasuresScreen';
import BalanceScreen from './screens/BalanceScreen';
import FriendsScreen from './screens/FriendsScreen';
import StakeScreen from './screens/StakeScreen';
import TasksScreen from './screens/TasksScreen';
import GamesScreen from './screens/GamesScreen';
import AdminScreen from './screens/AdminScreen';

const API_URL = (process.env as any).REACT_APP_API_URL || 'http://localhost:8000';
const MANIFEST_URL = (process.env as any).PUBLIC_URL 
  ? `${(process.env as any).PUBLIC_URL}/tonconnect-manifest.json`
  : 'https://treasureton.vercel.app/tonconnect-manifest.json';

const App = () => {
  const [tab, setTab] = useState('treasures' as TabKey);
  const [isAdmin, setIsAdmin] = useState(false);
  const walletAddress = (window as any)?.Telegram?.WebApp?.initDataUnsafe?.user?.id?.toString() || 'demo';

  // ✅ УБРАНА ЛОГИКА С localStorage - теперь start_param читается напрямую в BalanceScreen
  // Это решает проблему race condition

  // Проверяем права админа при загрузке
  useEffect(() => {
    const checkAdminAccess = async () => {
      try {
        const response = await axios.post(`${API_URL}/admin/check`, {
          telegram_id: walletAddress
        });
        setIsAdmin(response.data.is_admin || false);
      } catch (error) {
        setIsAdmin(false);
      }
    };
    
    checkAdminAccess();
  }, [walletAddress]);

  // Keep-alive пинг для предотвращения cold start на Railway
  useEffect(() => {
    const keepAlive = async () => {
      try {
        console.log('💓 Keep-alive пинг...');
        const start = Date.now();
        // Используем простой endpoint / вместо тяжёлого /admin/check
        await axios.get(`${API_URL}/`, { timeout: 30000 }); // 30 секунд для cold start
        console.log(`✅ Keep-alive OK (${Date.now() - start}ms)`);
      } catch (error: any) {
        console.warn('⚠️ Keep-alive ошибка:', error.message);
        // Если первая попытка failed, пробуем ещё раз через 5 секунд
        setTimeout(keepAlive, 5000);
      }
    };

    // Первый пинг сразу при загрузке
    keepAlive();

    // Пингуем каждые 5 минут (оптимальный баланс)
    const interval = setInterval(keepAlive, 5 * 60 * 1000);

    // Очищаем таймер при unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <TonConnectUIProvider manifestUrl={MANIFEST_URL}>
          <div className="min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600">
            <ErrorBoundary>
              {tab === 'treasures' && <TreasuresScreen walletAddress={walletAddress} />}
              {tab === 'balance' && <BalanceScreen />}
              {tab === 'friends' && <FriendsScreen />}
              {tab === 'stake' && <StakeScreen />}
              {tab === 'tasks' && <TasksScreen />}
              {tab === 'games' && <GamesScreen />}
              {tab === 'admin' && <AdminScreen />}
            </ErrorBoundary>
            <BottomNav active={tab} onChange={setTab} isAdmin={isAdmin} />
          </div>
        </TonConnectUIProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
};

export default App;
